import { EntryFormDetailsProvider } from "./context/entry-details";
import PropTypes from "prop-types";
import { entryFormDetailsReducer } from "./state/entry-form-details/reducer";
import styles from "./styles";
import CompetitionLayout from "./containers/competition-layout";

export default function App({ appConfig }) {
  return (
    <div className={styles.container}>
      <EntryFormDetailsProvider
        initialState={{
          loading: true,
          hasError: false,
          entryFormDetails: {
            firstName: "",
            lastName: "",
            telephone: "",
            emailAddress: "",
            termsAndConditions: "",
            privacyPolicy: "",
          },
        }}
        reducer={entryFormDetailsReducer}
      >
        <CompetitionLayout appConfig={appConfig} />
      </EntryFormDetailsProvider>
    </div>
  );
}

App.propTypes = {
  appConfig: PropTypes.shape({
    recaptchaSiteKey: PropTypes.string.isRequired,
  }),
};
